module.exports = __webpack_public_path__ + "img/logo_hola.7ed315fb.svg";